import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EvacuationStatut } from 'src/api/models';

@Component({
  selector: 'app-evacuation-status-select',
  templateUrl: './evacuation-status-select.component.html',
  styleUrls: ['./evacuation-status-select.component.css']
})
export class EvacuationStatusSelectComponent implements OnInit {

  @Input('status') public status  : number;
  @Output() statusChange = new EventEmitter<number>();

  @Input('width') width: number;

  @Input() cell: any;

  statutsEvacuation = [];

  constructor(private translateService: TranslateService) {     
    for (var t in EvacuationStatut) {
      let value = parseInt(t, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.statutsEvacuation.push({ id: value, name: this.translateService.instant('Evacuations.Statut.' + EvacuationStatut[t])});
      }
    }    
  }

  ngOnInit(): void {
  }

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.status);
    }    

    this.statusChange.emit(this.status);
  }   

}
